// Route: /courses/templates/$templateId — LEGACY redirect → /courses/catalog/$templateId.
//
// Карточка переехала вместе с каталогом (`routes/courses/catalog_.$templateId.tsx`).
// Роут сохранён редиректом: на него ведут прямые ссылки, которыми авторы делятся
// своими шаблонами, и пункты «Мои шаблоны» из старых кэшей клиента.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/courses/templates_/$templateId")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/courses/catalog/$templateId",
			params: { templateId: params.templateId },
			replace: true,
		});
	},
});
